"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E71C",
    fillRule: "evenodd",
    stroke: "#17181A",
    d: "M6.724 1.008c-.54-.053-.62.157-.787.765-.167.608-.915 2.377-1.444 3.277-.528.9-1.509 2.126-2.153 2.98-.645.854-.882.68-1.34.694v5.002h.914c.096-.03.518.103 1.265.399 1.12.444 2.772.855 4.07.855 1.299 0 3.752.15 4.917-.365 1.165-.513 1.003-.86 1.003-1.065 0-.138-.12-.38-.362-.729.72-.347 1.08-.727 1.08-1.14 0-.414-.239-.79-.718-1.129.554-.313.831-.718.831-1.215 0-.497-.35-.869-1.05-1.115.164-.285.244-.588.24-.908-.007-.48-.423-.94-1.364-.951-.941-.01-2.323.32-2.913.427-.59.108-1.748.094-1.801-1.03-.054-1.123.69-1.823.767-3.134.077-1.311-.616-1.566-1.155-1.618z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLike);
var _default = exports["default"] = Memo;